import { render, staticRenderFns } from "./VButtonSettings.vue?vue&type=template&id=20755770&"
import script from "./VButtonSettings.vue?vue&type=script&lang=ts&"
export * from "./VButtonSettings.vue?vue&type=script&lang=ts&"
import style0 from "./VButtonSettings.vue?vue&type=style&index=0&id=20755770&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports